import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#1C7E85",
  "fill-rule": "evenodd",
  d: "m7.09 8.19-1.443-.833a.3.3 0 0 0-.41.11l-2.894 5.012a.3.3 0 0 0 .242.45l1.562.09a.3.3 0 0 1 .233.133l.868 1.316a.3.3 0 0 0 .51-.016L8.653 9.44a.3.3 0 0 0-.11-.41z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#1C7E85",
  "fill-rule": "evenodd",
  d: "m8.91 8.19 1.444-.833a.3.3 0 0 1 .41.11l2.893 5.012a.3.3 0 0 1-.242.45l-1.562.09a.3.3 0 0 0-.233.133l-.868 1.316a.3.3 0 0 1-.51-.016L7.347 9.44a.3.3 0 0 1 .11-.41z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "8.002",
  cy: "6.723",
  r: "5.596",
  fill: "#FF9737"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M5.962 8.007a.45.45 0 0 0-.129-.399L4.657 6.462a.45.45 0 0 1 .25-.767l1.625-.237a.45.45 0 0 0 .339-.246l.726-1.472a.45.45 0 0 1 .807 0l.727 1.472a.45.45 0 0 0 .34.246l1.624.237a.45.45 0 0 1 .25.767l-1.177 1.146a.45.45 0 0 0-.129.399l.278 1.618a.45.45 0 0 1-.653.475L8.21 9.336a.45.45 0 0 0-.418 0l-1.454.764a.45.45 0 0 1-.653-.474z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }